import { render } from "./dutyHolidayRules.html?vue&type=template&id=5dbdcbcd&scoped=true&ts=true"
import script from "./dutyHolidayRules.ts?vue&type=script&lang=ts"
export * from "./dutyHolidayRules.ts?vue&type=script&lang=ts"

import "./dutyHolidayRules.scss?vue&type=style&index=0&id=5dbdcbcd&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbdcbcd"]])

export default __exports__